import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Phone } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "../types";

interface PhoneFieldProps {
  form: UseFormReturn<FormValues>;
  isEditing: boolean;
}

export function PhoneField({ form, isEditing }: PhoneFieldProps) {
  const currentPhone = form.watch('phone');

  const formatPhoneNumber = (value: string) => {
    if (!value) return value;
    const numbers = value.replace(/\D/g, '');
    if (numbers.startsWith('61')) {
      return '0' + numbers.slice(2);
    }
    if (numbers.startsWith('4')) {
      return '0' + numbers;
    }
    return numbers;
  };

  if (!isEditing) {
    return (
      <Card className="transition-all duration-200 hover:shadow-md">
        <div className="p-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-primary/10 p-2.5">
              <Phone className="h-5 w-5 text-primary" />
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-muted-foreground">Mobile Number</p>
              <p className="text-sm font-medium">{currentPhone || "Not set"}</p>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card className="transition-all duration-200">
      <div className="p-6">
        <FormField
          control={form.control}
          name="phone"
          rules={{
            pattern: {
              value: /^04\d{8}$/,
              message: "Please enter a valid Australian mobile number"
            }
          }}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Mobile Number</FormLabel>
              <FormControl>
                <div className="relative">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2">
                    <Phone className="h-4 w-4 text-muted-foreground" />
                  </div>
                  <Input 
                    placeholder="Enter mobile number"
                    className="pl-10"
                    {...field}
                    value={formatPhoneNumber(field.value || '')}
                    onChange={(e) => {
                      const formatted = formatPhoneNumber(e.target.value);
                      if (formatted.length <= 10) {
                        field.onChange(formatted);
                      }
                    }}
                  />
                </div>
              </FormControl>
              <FormMessage />
              <p className="text-sm text-muted-foreground">
                Australian mobile number starting with 04
              </p>
            </FormItem>
          )}
        />
      </div>
    </Card>
  );
}